export const ENTER = "Enter";
export const ESC = "Escape";
export const ARROW_RIGHT = "ArrowRight";
export const ARROW_LEFT = "ArrowLeft";
